// extracted by mini-css-extract-plugin
export default {"emailField":"QNAWXYiT","idField":"MNfeP4ZH"};